<template>
    <div>
      <div class="container mt-4">
        <h2 class="text-center mb-4">Calendario de Rentas</h2>
        <FullCalendar :options="calendarOptions" />
      </div>
    </div>
  </template>
  
  <script>
  import FullCalendar from "@fullcalendar/vue3";
  import dayGridPlugin from "@fullcalendar/daygrid";
  import interactionPlugin from "@fullcalendar/interaction";
  import esLocale from "@fullcalendar/core/locales/es";
  import axios from "axios";
  import baseUrl from "../api";
  import Swal from "sweetalert2";
  import { mapState } from 'vuex';

  
  export default {
    name: "CalendarioRentas",
    components: {
      FullCalendar,

    },
    computed: {
  ...mapState(['id_usuario'])  // ✅ Correcto: así Vuex mapea el id_usuario al componente
},
data() {
  return {
    eventos: [],
    calendarOptions: {
      plugins: [dayGridPlugin, interactionPlugin],
      initialView: "dayGridMonth",
      locale: esLocale,
      events: [],
      eventDisplay: "block",
      eventClick: this.handleEventClick,
      eventMouseEnter: function(info) {
  info.el.style.cursor = 'pointer';
},

      // 🧠 TOOLTIP AUTOMÁTICO CORREGIDO
      eventDidMount: function(info) {
  const tipo = info.event.extendedProps.tipo;

  if (tipo === 'entrega') {
    const pendientes = info.event.extendedProps.pendientesEntrega || 0;
    const estado = info.event.extendedProps.estadoEntrega;

    if (estado === 'entregado') {
      info.el.setAttribute("title", "✅ Todos los vestidos han sido entregados");
    } else {
      info.el.setAttribute("title", `❗ Faltan por entregar: ${pendientes}`);
    }
  }

  if (tipo === 'recogida') {
    const pendientesR = info.event.extendedProps.pendientesRecogida || 0;
    const pendientesA = info.event.extendedProps.pendientesAjustes || 0;

    if (pendientesR === 0 && pendientesA === 0) {
      info.el.setAttribute("title", "✅ Todos los vestidos han sido recogidos y los ajustes están completos");
    } else {
      let mensaje = "❗ Pendientes:\n";
      if (pendientesR > 0) mensaje += `• Por recoger: ${pendientesR}\n`;
      if (pendientesA > 0) mensaje += `• Ajustes por completar: ${pendientesA}`;
      info.el.setAttribute("title", mensaje.trim());
    }
  }
}

    }
  };
},



    mounted() {
      this.obtenerRentas();
    },
    methods: {
        async handleEventClick(info) {
  const fechaSeleccionada = info.event.startStr.split("T")[0];
  const esRecoge = info.event.title.includes("Recogen");

  try {
    const response = await axios.get(`${baseUrl}/api/rentas-ver`);
    const seguimientoResponse = await axios.get(`${baseUrl}/api/seguimiento`);
    const rentas = response.data;
    const seguimientos = seguimientoResponse.data;

    const coincidencias = rentas.filter(r => {
        
      const fecha = esRecoge ? r.fecha_recoge : r.fecha_entrega;
      return fecha && fecha.split("T")[0] === fechaSeleccionada;
    });

    if (coincidencias.length === 0) {
      Swal.fire("Sin rentas", `No hay vestidos para ${esRecoge ? "recoger" : "entregar"} el ${fechaSeleccionada}.`, "info");
      return;
    }
    const pendientesPorEntregar = coincidencias.filter(r => {
  const seguimiento = seguimientos.find(s => s.id_renta === r.id_renta) || {};
  return seguimiento.entregado !== 'si';
});

let mensajeGlobal = "";

if (esRecoge) {
  const pendientesPorRecoger = coincidencias.filter(r => {
    const seguimiento = seguimientos.find(s => s.id_renta === r.id_renta) || {};
    return seguimiento.recogio !== 'si';
  });

  const pendientesAjustes = coincidencias.filter(r => {
    return r.ajustes === 'si' && (
      !seguimientos.find(s => s.id_renta === r.id_renta)?.ajustes_completados ||
      seguimientos.find(s => s.id_renta === r.id_renta).ajustes_completados !== 'si'
    );
  });

  if (pendientesPorRecoger.length === 0) {
    mensajeGlobal += `
      <div style="padding: 10px; background: #e8f5e9; color: #2e7d32; font-weight: bold; border-radius: 8px; margin-bottom: 5px;">
        ✅ Todos los vestidos han sido recogidos
      </div>`;
  } else {
    mensajeGlobal += `
      <div style="padding: 10px; background: #fff3e0; color: #e65100; font-weight: bold; border-radius: 8px; margin-bottom: 5px;">
        ❗ Faltan por recoger: ${pendientesPorRecoger.length} ${pendientesPorRecoger.length === 1 ? 'vestido' : 'vestidos'}
      </div>`;
  }

  if (pendientesAjustes.length === 0) {
    mensajeGlobal += `
      <div style="padding: 10px; background: #e8f5e9; color: #33691e; font-weight: bold; border-radius: 8px; margin-bottom: 10px;">
        ✅ Todos los ajustes han sido completados
      </div>`;
  } else {
    mensajeGlobal += `
      <div style="padding: 10px; background: #fff3e0; color: #e65100; font-weight: bold; border-radius: 8px; margin-bottom: 10px;">
        ❗ Faltan por completar: ${pendientesAjustes.length} ${pendientesAjustes.length === 1 ? 'ajuste' : 'ajustes'}
      </div>`;
  }
}

if (!esRecoge) {
  if (pendientesPorEntregar.length === 0) {
    mensajeGlobal = `<div style="padding: 10px; background: #e8f5e9; color: #2e7d32; font-weight: bold; border-radius: 8px; margin-bottom: 10px;">
      ✅ Todos tus vestidos han sido entregados
    </div>`;
  } else {
    mensajeGlobal = `<div style="padding: 10px; background: #fff3e0; color: #e65100; font-weight: bold; border-radius: 8px; margin-bottom: 10px;">
      🚚 Faltan por entregar: ${pendientesPorEntregar.length} ${pendientesPorEntregar.length === 1 ? 'vestido' : 'vestidos'}
    </div>`;
  }
}

const htmlForm = coincidencias.map((r, index) => {
  const seguimiento = seguimientos.find(s => s.id_renta === r.id_renta) || {};

  const precioRentado = Number(r.precio_rentado) || 0;
  const costoAjustes = Number(r.costo_ajustes) || 0;
  const anticipo = Number(r.anticipo) || 0;
  const restoPagado = Number(seguimiento.cant_pago_resto) || 0;

  const totalRenta = precioRentado + costoAjustes;
  const totalPagado = anticipo + restoPagado;

  const yaPagado = totalPagado >= totalRenta;


  const ajustesListos = seguimiento.ajustes_completados === 'si';
  const imagen = r.foto_vestido ? `${baseUrl}/${r.foto_vestido}` : "https://via.placeholder.com/120x160?text=Sin+imagen";
  const modelo = r.modelo_vestido || "Sin modelo";

  return `
  
  <div data-index="${index}" data-id="${r.id_renta}" class="renta-item" style="background: #fdfdfd; border-radius: 12px; padding: 15px; margin-bottom: 16px; border: 1px solid #e0e0e0; text-align: left; box-shadow: 0 2px 8px rgba(0,0,0,0.05); display: flex; gap: 15px;">
    <img src="${imagen}" alt="Foto vestido" style="width: 100px; height: 140px; object-fit: cover; border-radius: 8px; border: 1px solid #ddd;" />
    <div style="flex: 1">
      <div style="font-weight: 700; font-size: 1.2rem; color: ${esRecoge ? "#f5009b" : "#c2185b"}; margin-bottom: 5px;">
        ${esRecoge ? '👗 Vestido para RECOGER' : '📦 Vestido para ENTREGAR'}
      </div>
      <div><b>Nombre:</b> ${r.nombre_clienta}</div>
      <div><b>Teléfono:</b> ${r.telefono}</div>
      <div><b>Modelo:</b> ${modelo}</div>
      <div><b>${esRecoge ? "Fecha de recogida" : "Fecha de entrega"}:</b> ${fechaSeleccionada}</div>

      ${esRecoge && r.ajustes === 'si' ? `
        <hr style="margin: 12px 0;" />
        <div><b>Ajustes:</b></div>
        ${ajustesListos ? `
          <div style="color: green; font-weight: bold;">✅ Ajustes completados</div>
          <div style="color: green; margin-top: 4px;">📝 ${seguimiento.descripcion_ajustestomados || 'Sin descripción'}</div>
        ` : `
          <label>
            <input type="checkbox" class="ajustes_tomados" ${seguimiento.ajustes_tomados === 'si' ? 'checked' : ''}/> Ajustes tomados
          </label><br>
          <div class="descripcion-ajustes" style="margin-top: 8px; ${seguimiento.ajustes_tomados === 'si' ? '' : 'display:none'}">
            <textarea class="descripcion_ajustestomados" placeholder="Describe los ajustes tomados" rows="2" style="width: 100%; border-radius: 6px; border: 1px solid #ccc; padding: 6px;">${seguimiento.descripcion_ajustestomados || ''}</textarea>
          </div>
          <label><input type="checkbox" class="ajustes_completados" ${seguimiento.ajustes_completados === 'si' ? 'checked' : ''}/> Ajustes completados</label><br>
        `}
        <hr style="margin: 12px 0;" />
      ` : ''}

${esRecoge
  ? `<label><input type="checkbox" class="recogio" ${seguimiento.recogio === 'si' ? 'checked' : ''}/> Cliente recogió</label><br>`
  : `<label><input type="checkbox" class="entregado" ${seguimiento.entregado === 'si' ? 'checked' : ''}/> Cliente entregó</label><br>`
}

      ${yaPagado ? `
  <div class="pago-extra" style="margin-top: 10px;">
    <div class="pago-exito" style="color: green; font-weight: bold;">¡Pagado!</div>
  </div>
` : `
  <div class="pago-extra" style="margin-top:10px; ${seguimiento.recogio === 'si' ? '' : 'display:none'}">
    <div class="pendiente-texto"><b>Pendiente de pago:</b> $${(totalRenta - anticipo).toFixed(2)}</div>
    <input class="cant_pago" type="number" placeholder="Cantidad pagada" value="${seguimiento.cant_pago_resto || ''}" /><br>
    <select class="forma_pago">
      <option value="">Forma de pago</option>
      <option value="efectivo" ${seguimiento.forma_pago_resto === 'efectivo' ? 'selected' : ''}>Efectivo</option>
      <option value="transferencia" ${seguimiento.forma_pago_resto === 'transferencia' ? 'selected' : ''}>Transferencia</option>
      <option value="tarjeta" ${seguimiento.forma_pago_resto === 'tarjeta' ? 'selected' : ''}>Tarjeta</option>
    </select><br>
  </div>

      `}

     ${
  (esRecoge && seguimiento.recogio === 'si') || (!esRecoge && seguimiento.entregado === 'si')
    ? ''
    : `<a href="https://wa.me/52${r.telefono}?text=${encodeURIComponent(esRecoge
        ? `Hola ${r.nombre_clienta}, te saludamos con cariño desde Miss Coquette 💖. Tu vestido ya está listo y te esperamos hoy para recogerlo, en un horario de 2:30 p.m. a 7:30 p.m. ¡Gracias por tu confianza!`
        : `Hola ${r.nombre_clienta}, te saludamos de Miss Coquette 💖. Solo queremos recordarte que hoy es la entrega de tu vestido. Te esperamos en un horario de 2:30 p.m. a 7:30 p.m. ¡Gracias por permitirnos ser parte de tu evento!`)}"
       target="_blank"
       style="display: inline-block; margin-top: 10px; background: #25d366; color: white; padding: 8px 12px; border-radius: 6px; text-decoration: none; font-weight: bold;">
       📲 Enviar WhatsApp</a>`
}
    </div>
  </div>
  `;
}).join("");



await Swal.fire({
  title: esRecoge
    ? `👗 Vestidos para recoger el ${fechaSeleccionada}`
    : `📦 Vestidos para entregar el ${fechaSeleccionada}`,
  html: `
    <div class="swal2-html-container">
      ${mensajeGlobal}
      ${htmlForm}
    </div>
  `,
  customClass: {
    popup: 'scrollable-modal'
  },
  showCloseButton: true,
  confirmButtonText: 'Guardar cambios',
  width: 700,
  didOpen: () => {
    document.querySelectorAll(".entregado").forEach(checkbox => {
      checkbox.addEventListener("change", (e) => {
        console.log("Cliente entregó cambiado:", e.target.checked);
      });
    });

    document.querySelectorAll(".recogio").forEach(checkbox => {
      checkbox.addEventListener("change", (e) => {
        const container = e.target.closest(".renta-item");
        const pagoExtra = container.querySelector(".pago-extra");
        pagoExtra.style.display = e.target.checked ? "block" : "none";
      });
    });

    document.querySelectorAll(".ajustes_tomados").forEach(checkbox => {
      checkbox.addEventListener("change", (e) => {
        const container = e.target.closest(".renta-item");
        const descripcion = container.querySelector(".descripcion-ajustes");
        descripcion.style.display = e.target.checked ? "block" : "none";
      });
});

  },
 
  preConfirm: async () => {
  const items = document.querySelectorAll(".renta-item");
  const actualizaciones = [];

  for (const item of items) {
    const id_renta = item.dataset.id;
    const actualizacion = { id_renta, id_usuario: this.id_usuario };

    const ajustesTomados = item.querySelector(".ajustes_tomados");
    if (ajustesTomados) {
      actualizacion.ajustes_tomados = ajustesTomados.checked ? 'si' : 'no';
    }

    const ajustesCompletados = item.querySelector(".ajustes_completados");
    if (ajustesCompletados) {
      actualizacion.ajustes_completados = ajustesCompletados.checked ? 'si' : 'no';
    }

    const recogio = item.querySelector(".recogio");
    if (recogio) {
      actualizacion.recogio = recogio.checked ? 'si' : 'no';
    }
    const entregado = item.querySelector(".entregado");
if (entregado) {
  actualizacion.entregado = entregado.checked ? 'si' : 'no';
}


    const descripcion = item.querySelector(".descripcion_ajustestomados");
    if (descripcion && descripcion.value.trim() !== "") {
      actualizacion.descripcion_ajustestomados = descripcion.value.trim();
    }

    const cant_pago_input = item.querySelector(".cant_pago");
    const forma_pago_select = item.querySelector(".forma_pago");

    if (cant_pago_input && cant_pago_input.value.trim() !== "") {
      const cantidad = cant_pago_input.value.trim();
      if (!forma_pago_select || forma_pago_select.value === "") {
        Swal.showValidationMessage(`Por favor selecciona la forma de pago para la cantidad ingresada`);
        return false;
      }
      actualizacion.cant_pago_resto = cantidad;
      actualizacion.forma_pago_resto = forma_pago_select.value;
    }

    actualizaciones.push(actualizacion);
  }

  try {
    for (const seguimiento of actualizaciones) {
      await axios.put(`${baseUrl}/api/seguimiento/${seguimiento.id_renta}`, seguimiento);
    }

    await Swal.fire("Éxito", "Cambios guardados correctamente", "success").then(async () => {
  await this.obtenerRentas();       // 🌀 1. Actualiza colores del calendario
  this.handleEventClick(info);      // 🌀 2. Vuelve a abrir el modal actualizado
});


  } catch (err) {
    console.error(err);
    Swal.fire("Error", "No se pudieron guardar los cambios", "error");
  }
}



});

   

  } catch (error) {
    console.error("Error al obtener rentas", error);
    Swal.fire("Error", "No se pudo cargar la información de rentas.", "error");
  }
}
,
async obtenerRentas() {
  try {
    const response = await axios.get(`${baseUrl}/api/rentas-ver`);
    const seguimientoResponse = await axios.get(`${baseUrl}/api/seguimiento`);
    const rentas = response.data;
    const seguimientos = seguimientoResponse.data;

    const eventos = [];

    // 🔄 Recorremos todas las rentas por fecha de entrega
    const fechasEntrega = [...new Set(rentas.map(r => r.fecha_entrega?.split("T")[0]).filter(Boolean))];
    for (const fecha of fechasEntrega) {
      const rentasDelDia = rentas.filter(r => r.fecha_entrega?.split("T")[0] === fecha);

      let hayPendientes = false;
      let contadorPendientes = 0;

      for (const r of rentasDelDia) {
        const seguimiento = seguimientos.find(sg => sg.id_renta === r.id_renta);
        if (!seguimiento || seguimiento.entregado !== 'si') {
          hayPendientes = true;
          contadorPendientes++;
        }
      }

      eventos.push({
        title: `${hayPendientes ? '❗' : '✅'} Entregan (${rentasDelDia.length})`,
        start: fecha,
        color: hayPendientes ? '#f06292' : '#81c784',
        extendedProps: {
          tipo: 'entrega',
          pendientesEntrega: contadorPendientes,
          estadoEntrega: hayPendientes ? 'pendiente' : 'entregado'
        }
      });
    }

    // 🔄 Recorremos todas las rentas por fecha de recogida
    const fechasRecoge = [...new Set(rentas.map(r => r.fecha_recoge?.split("T")[0]).filter(Boolean))];
    for (const fecha of fechasRecoge) {
      const rentasDelDia = rentas.filter(r => r.fecha_recoge?.split("T")[0] === fecha);

      let pendientesRecoger = 0;
      let pendientesAjustes = 0;

      for (const r of rentasDelDia) {
        const seguimiento = seguimientos.find(sg => sg.id_renta === r.id_renta);
        if (!seguimiento || seguimiento.recogio !== 'si') {
          pendientesRecoger++;
        }
        if (r.ajustes === 'si' && (!seguimiento || seguimiento.ajustes_completados !== 'si')) {
          pendientesAjustes++;
        }
      }

      const hayPendientes = pendientesRecoger > 0 || pendientesAjustes > 0;

      eventos.push({
        title: `${hayPendientes ? '❗' : '✅'} Recogen (${rentasDelDia.length})`,
        start: fecha,
        color: hayPendientes ? '#f06292' : '#81c784',
        extendedProps: {
          tipo: 'recogida',
          pendientesRecogida: pendientesRecoger,
          pendientesAjustes: pendientesAjustes,
          estadoRecogida: hayPendientes ? 'pendiente' : 'recogido'
        }
      });
    }

    this.calendarOptions.events = eventos;
  } catch (error) {
    console.error("Error al obtener rentas:", error);
  }
}





    
  


      
    }
  };
  </script>
  
  
  
  <style scoped>
 .container {
  max-width: 100%;
  padding: 20px 15px;
  margin-top: 0;
}

h2 {
  font-size: 28px;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
}

/* FullCalendar */
.fc {
  width: 100% !important;
  background-color: white;
  border-radius: 16px;
  padding: 10px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
}

.fc-scrollgrid {
  width: 100% !important;
  table-layout: fixed !important;
}

.fc-daygrid-day-frame {
  min-height: 70px;
  padding: 2px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

/* 🔽 SweetAlert2 Modal Compacto con Scroll */
.swal2-popup.scrollable-modal {
  max-height: 85vh !important;
  overflow-y: auto !important;
  padding: 20px !important;
  width: 95% !important;
  max-width: 700px !important;
  border-radius: 16px !important;
}

.swal2-html-container {
  max-height: 70vh !important;
  overflow-y: auto !important;
  padding-right: 8px;
  text-align: left;
}

/* ✅ Ajustes responsive para móviles */
@media (max-width: 480px) {
  .container {
    top: -190px;
  }

  h2 {
    font-size: 20px;
    margin-bottom: 10px;
  }

  .fc {
    padding: 8px;
    font-size: 12px;
  }

  .fc-daygrid-day-frame {
    min-height: 50px;
    padding: 1px;
  }

  .fc-event {
    font-size: 0.75rem;
    padding: 4px 6px;
    border-radius: 6px;
  }

  .fc-toolbar-title {
    font-size: 1rem !important;
  }

  /* 🔽 Compactar tarjetas de vestidos dentro del modal */
  .renta-item {
    flex-direction: column !important;
    align-items: center !important;
    text-align: center !important;
  }

  .renta-item img {
    width: 90px !important;
    height: 120px !important;
  }

  .renta-item textarea,
  .renta-item select,
  .renta-item input {
    font-size: 0.85rem !important;
    width: 100% !important;
  }
}


  </style>
  